import groupBy from 'lodash/groupBy';

import { TFunction } from '@lyearn/i18n';
import {
  Calendar2Outline,
  Flag2Outline,
  FlashOutline,
  MeetingOutline,
  PersonOutline,
} from '@lyearn/icons';
import { FilterOption } from '@/components/Filter/types';
import { getIcon } from '@/modules/tasks/views/TasksDashboard/utils/getSidebarItems';
import { UserViewFieldEntityTypeEnum } from '@/types/schema';

import { FileFragment } from '../../graphql/fragments/generated/file';
import { TaskGroupByEnum } from '../TaskDashboard/types';
import { TaskGroupByFilterProps } from './types';

export const getTaskGroupByStaticOptions = (
  t: TFunction,
  taskViewConfigs: FileFragment['taskViewConfigs'],
  isMyTasks?: boolean,
): FilterOption[] => {
  const availableFieldsFromTaskViewConfigs = taskViewConfigs?.map((config) => config.label) || [];
  const options = [];
  options.push({
    Icon: FlashOutline,
    value: TaskGroupByEnum.Status,
    label: t('Common:Sort.Status'),
  });
  if (!isMyTasks) {
    options.push({
      Icon: PersonOutline,
      value: TaskGroupByEnum.Assignee,
      label: t('Common:Filter.Assignee'),
    });
  }
  if (availableFieldsFromTaskViewConfigs.includes('priority')) {
    options.push({
      Icon: Flag2Outline,
      value: TaskGroupByEnum.Priority,
      label: t('Common:Filter.Priority'),
    });
  }
  if (availableFieldsFromTaskViewConfigs.includes('dueDate')) {
    options.push({
      Icon: Calendar2Outline,
      value: TaskGroupByEnum.DueDate,
      label: t('Task:Filter.DueDate'),
    });
  }
  if (availableFieldsFromTaskViewConfigs.includes('stage')) {
    options.push({
      Icon: MeetingOutline,
      value: TaskGroupByEnum.Stage,
      label: t('Task:Filter.Stage'),
    });
  }
  return options;
};

export const TAG_GROUP_ID_PREFIX = 'tag:';

export const isGroupedByTag = (groupBy?: string) => groupBy?.startsWith(TAG_GROUP_ID_PREFIX);

export const isGroupedByStatus = (groupBy?: string) => groupBy === 'status';

export const getTagGroupById = (tagId: string) => `${TAG_GROUP_ID_PREFIX}${tagId}`;

export const getTaskTagGroupByOptions = (
  taskViewConfigs: TaskGroupByFilterProps['taskViewConfigs'],
) => {
  const tagsFilterOptions: FilterOption[] = (taskViewConfigs || [])
    .filter(
      ({ entityType, tagEntitySettings }) =>
        entityType === UserViewFieldEntityTypeEnum.Tag && !tagEntitySettings?.disableGrouping,
    )
    .map((config) => ({
      label: config.name,
      provider: config.provider,
      value: getTagGroupById(config.entityId!),
      Icon: () => getIcon(config.iconSettings),
    }));

  return groupBy(tagsFilterOptions, 'provider');
};
